module.exports = __webpack_public_path__ + "media/images/flags/MW-f39d2ffbe4b4164f428dc19c35d89d85.svg";